import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Table from '../Tables/Table';
import Pagination from '../Pagination/Pagination';
import Loader from '../Loader/Loader';

const TableAndPagination = ({
  onChange, totalPage, page, limit, data, header, onClick, limitCounts, hidePagination, sort, sortBy, onSortBy,
}) => {
  const [loading, setLoading] = useState(false);

  const onChangeLoading = async (path, count) => {
    setLoading(true);
    await onChange(path, count);
    setLoading(false);
  };

  return (
    <>
      <div style={{
        position: 'relative', height: '100%', width: '100%',
      }}
      >
        {loading && <Loader />}

        <Table data={data} header={header} onClick={onClick} sort={sort} sortBy={sortBy} onSortBy={onSortBy} />
      </div>

      {!!data.length && !hidePagination && (
      <Pagination
        onChange={onChangeLoading}
        page={page}
        totalPage={totalPage}
        limit={limit}
        limitCounts={limitCounts}
      />
      )}
    </>
  );
};

TableAndPagination.propTypes = {
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  totalPage: PropTypes.number,
  page: PropTypes.number,
  limit: PropTypes.number,
  limitCounts: PropTypes.array,
  header: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  hidePagination: PropTypes.bool,
  sortBy: PropTypes.string,
  sort: PropTypes.oneOf(['asc', 'desc']),
  onSortBy: PropTypes.func,
};

TableAndPagination.defaultProps = {
  totalPage: 1,
  page: 1,
  limit: 15,
  onClick: () => {},
  limitCounts: [
    {
      id: 0,
      count: 15,
    },
    {
      id: 1,
      count: 30,
    },
    {
      id: 2,
      count: 60,
    },
    {
      id: 3,
      count: 100,
    },
  ],
  hidePagination: false,
  sort: undefined,
  sortBy: undefined,
  onSortBy: undefined,
};

export default TableAndPagination;
